import { departments } from '../store/enums';

import { HubSpotSVG, SalesforceSVG } from './svgs';

const MonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const CRMS = {
  7001: 'hubspot',
  7002: 'salesforce',
};
const GLOBAL_LIST_IDS = {
  contact: 'all-contacts',
  company: 'all-companies',
};
const RESERVED_LISTS = Object.values(GLOBAL_LIST_IDS);

const CONSUMED_VIA_MAP = {
  ENRICHMENT_API: 'Enrichment',
  ENRICHMENT_UI: 'Enrichment',
  PROSPECTOR_REVEAL: 'Revealed via Prospector',
  DYNAMIC_LIST_EXPORT: 'Exported in Export Request',
  LIST_REFRESH: 'Refreshed via List',
};

const crmUnAuthToastBody = (
  <span>
    CRM integrations are available on Growth plan and above.{' '}
    <a href='/pricing' className='text-blue-600 underline'>
      Upgrade your plan
    </a>
  </span>
);
const CRMsFormatted = {
  7001: 'HubSpot',
  7002: 'Salesforce',
};
const CRMSvgs = {
  7001: <div className='w-5 h-5 fill-hubspot-orange'>{HubSpotSVG}</div>,

  7002: <div className='w-5 h-5 fill-salesforce-blue'>{SalesforceSVG}</div>,
};
class CRMTypes {
  static HUBSPOT = 7001;

  static SALESFORCE = 7002;
}
function getDepartment(department) {
  if (department === 'other') return 'Other';
  return departments[department] || null;
}

const SearchType = {
  CONTACT: 'contact',
  COMPANY: 'company',
};

const WAPPALYZER_CDN_URL =
  'https://cdn.jsdelivr.net/gh/wappalyzer/wappalyzer/src/drivers/webextension/images/icons/';

const URLLimits = {
  CONTACT_SOCIAL: 10000,
  COMPANY_SOCIAL: 10000,
};
export const MAX_EXPORT_RECORDS = 10000;

const SEMANTIC_SEARCH_LIMITS = {
  free: 50,
  professional: 200,
  growth: 500,
  scale: 1000,
  enterprise: 1000,
};

export const LEGACY_DYNAMIC_LISTS_DEPRECATION_DATE = 1664323200;

export {
  MonthNames,
  CRMS,
  CRMsFormatted,
  CRMSvgs,
  CRMTypes,
  GLOBAL_LIST_IDS,
  RESERVED_LISTS,
  CONSUMED_VIA_MAP,
  crmUnAuthToastBody,
  WAPPALYZER_CDN_URL,
  SEMANTIC_SEARCH_LIMITS,
  SearchType,
  URLLimits,
  getDepartment,
};
